import React from 'react';
import styles from './optionsContainer.module.css';

interface Props {
  options: any[];
  product: any;
  allOptions: any;
}

export default function OptionsContainer({ options, product, allOptions }: Props) {
  return (
    <div>
      {options?.length > 0 &&
        options?.map((option, index) => (
          <p key={index} className={styles.variantOption}>
            <span className={styles.variantOptionHeading}>{option?.name}:</span>{' '}
            <span className={styles.variantOptionValue}>
              {allOptions[product.id]?.[`option${index + 1}`] || 'N/A'}{' '}
            </span>
          </p>
        ))}
    </div>
  );
}
